import React, { useEffect, useState } from 'react';

import { AwpContainer } from '@components/Common/AwpContainer';
import DataFilters from './DataFilter';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import { STATE_STATUS } from '@awp/constants';
import FrostProbeGraph from './FrostProbeGraph';
import { FrostProbeContextProvider, useFrostProbeContext } from './FrostProbeContext';
import { useSelector } from 'react-redux';
import { selectStatus } from '@awp/stores/dataVisualizationSlice';
import { Crud } from '@awp/shared/Crud';

const FrostProbe = () => {
  return (
    <AwpContainer>
      <FrostProbeContextProvider>
        <FrostProbeWrapper />
      </FrostProbeContextProvider>
    </AwpContainer>
  );
};

const FrostProbeWrapper = () => {
  const status = useSelector(selectStatus);
  const { loading: fpLoading } = useFrostProbeContext();
  const [loading, setLoading] = useState(false);

  const crud = new Crud('Frost Probe');

  useEffect(() => {
    setLoading(status.data === STATE_STATUS.LOADING);
  }, [status]);

  return (
    <div style={{ position: 'relative' }}>
      <Form>
        <Form.Row>
          <Col lg={6} md={6} sm={4}>
            {crud.getHeader()}
          </Col>
        </Form.Row>
      </Form>
      <DataFilters />
      <Row>
        <Col lg={12} md={12}>
          {loading || fpLoading ? (
            <div className="frostprobe_Loading">
              <Spinner animation="border" />
            </div>
          ) : (
            <FrostProbeGraph />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FrostProbe;
